/* 
	203665 2020/10/16
	IndexDb Config
*/
const DB_NAME = "DLB";
const DB_VERSION = 1;
let DB;

export default {
  async getDb() {
    return new Promise((resolve, reject) => {
      if (DB) {
        return resolve(DB);
      }
      let request = window.indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = (e) => {
        console.log("Error opening db", e);
        reject("Error");
      };

      request.onsuccess = (e) => {
        DB = e.target.result;
        resolve(DB);
      };

      request.onupgradeneeded = (e) => {
        let db = e.target.result;
        db.createObjectStore("data", {
          autoIncrement: true,
          keyPath: "TrSetName",
        });
      };
    });
  },
  async deleteAll() {
    let db = await this.getDb();

    return new Promise((resolve) => {
      console.log("clear Data");
      let trans = db.transaction(["data"], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };

      let store = trans.objectStore("data");
      store.clear();
    });
  },

  async deleteByKey(tranName) {
    let db = await this.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["data"], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };

      let objectStore = trans.objectStore("data");
      objectStore.delete(tranName);
    });
  },

  async getData() {
    let db = await this.getDb();

    return new Promise((resolve) => {
      let trans = db.transaction(["data"], "readonly");
      trans.oncomplete = () => {
        resolve(data);
      };

      let store = trans.objectStore("data");
      let data = [];

      store.openCursor().onsuccess = (e) => {
        let cursor = e.target.result;
        if (cursor) {
          data.push(cursor.value);
          cursor.continue();
        }
      };
    });
  },

  async getDataByTrName(tranName) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      let trans = db.transaction(["data"], "readonly");
      trans.oncomplete = () => {
        resolve(data);
      };

      let data = [];
      let objectStore = trans.objectStore("data");
      let objectStoreRequest = objectStore.get(tranName);

      objectStoreRequest.onsuccess = function() {
        data.push(objectStoreRequest.result);
      };
    });
  },

  async saveData(dataset) {
    let db = await this.getDb();
    return new Promise((resolve) => {
      let trans = db.transaction(["data"], "readwrite");
      trans.oncomplete = () => {
        resolve();
      };

      let store = trans.objectStore("data");
      store.put(dataset);
    });
  },
};
